
export function get_youtube_id(media_link) {
    return media_link.split("watch?v=")[1];
}
